export const PageText = {
  _1: 'What is air pollution?',
  _2: 'Air pollution occurs when gases, dust particles, fumes or odour are introduced into the atmosphere and make it harmful to humans, animals and plant.'
};

export const Categories = {
  _1: {
    title: 'Outdoor pollution',
    subcategories: [
      {
        key: 0,
        subtitle: 'Several sources',
        text: 'Air pollution can result from both human and natural actions (e.g. wind erosion). Human activities that result in air pollution include emissions from industries and manufacturing activities, the burning of fossil fuels and household & farming chemicals.'
      },
      {
        key: 1,
        subtitle: 'The main pollutants',
        text: 'The main outdoor pollutants in Europe are Particulate Matter (PM), Ozone (O<sub>3</sub>) & Nitrogen Dioxide (NO<sub>2</sub>). aircheckr takes all these pollutants into account. The API response also contains information on the main pollutant(s) and the sources.'
      }
    ]
  },
  _2: {
    title: 'PM',
    subcategories: [
      {
        key: 0,
        subtitle: 'Particulate Matter',
        text: 'This is formed through chemical reactions, fuel combustion (e.g., burning coal, wood, diesel), industrial processes, farming (ploughing, field burning), and unpaved roads or during road constructions. PM affects more people than any other pollutant. The most health-damaging particles are those with a diameter of 10 microns or less, (PM<sub>10</sub>), which can penetrate and lodge deep inside the lungs. For this reason, aircheckr is also modelling PM<sub>2.5</sub>, particles with a diameter of 2.5 microns or less.'
      }
    ]
  },
  _3: {
    title: 'O<sub>3</sub>',
    subcategories: [
      {
        key: 0,
        subtitle: 'Ground-level Ozone',
        text: 'Secondary pollutant formed by chemical reaction of volatile organic compounds (VOCs) and NO<sub>x</sub> in the presence of sunlight. As a result, the highest levels of ozone pollution occur during periods of sunny weather.'
      }
    ]
  },
  _4: {
    title: 'NO<sub>2</sub>',
    subcategories: [
      {
        key: 0,
        subtitle: 'Nitrogen Dioxide',
        text: 'The main sources are fuel combustion (electric utilities, big industrial boilers, vehicles) and wood burning. As an air pollutant, NO<sub>2</sub> has several correlated activities. this way, NO<sub>2</sub> is also the main source of nitrate aerosols, which form an important fraction of PM<sub>2.5</sub> and, in the presence of ultraviolet light, of ozone.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/what-is-air-pollution_page.js